export default __webpack_public_path__ + "c1210e5ebe4344da508396540be7f52c.woff2";